module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-03 (1).42f0ce27.svg";